import {FC} from 'react';
import {IconButton, Stack} from '@mui/material';
import {LinkOff, Star} from '@mui/icons-material';
import {EditIcon} from '../../../icons/EditIcon';
import {BexioAccountActionsProps} from './BexioAccountActions.types';
import {bexioActionsSx} from './BexioAccountActions.sx';

export const BexioAccountActions: FC<BexioAccountActionsProps> = ({
                                                                      bexioAccountId,
                                                                      isPrimary,
                                                                      onUnlink,
                                                                      onMakePrimary,
                                                                      onUpdate,
                                                                  }) => {
    const handleUnlinkClick = () => {
        onUnlink(bexioAccountId);
    };

    const handleMakePrimaryClick = () => {
        onMakePrimary(bexioAccountId);
    };

    const handleUpdateClick = () => {
        onUpdate(bexioAccountId);
    };

    return (
        <Stack sx={bexioActionsSx.root}>
            <IconButton
                sx={bexioActionsSx.button}
                onClick={handleMakePrimaryClick}
                disabled={isPrimary}
            >
                <Star sx={bexioActionsSx.icon}/>
            </IconButton>

            <IconButton
                sx={bexioActionsSx.button}
                onClick={handleUpdateClick}
            >
                <EditIcon/>
            </IconButton>

            <IconButton
                sx={bexioActionsSx.button}
                onClick={handleUnlinkClick}
            >
                <LinkOff sx={bexioActionsSx.icon}/>
            </IconButton>
        </Stack>
    );
};